{
  "pageTitle": "Mapa nośników",
  "search": {
    "placeholder": "Wklej współrzędne lub wpisz adres, np. Braniborska, Wrocław",
    "submitLabel": "Szukaj",
    "clearLabel": "Wyczyść wyszukiwanie",
    "coordinateHint": "Pokazano punkt: {{latitude}}, {{longitude}}",
    "invalidHint": "Wklej współrzędne, np. 52.2297, 16.1234",
    "geocodingLoading": "Szukam lokalizacji...",
    "geocodingNotFound": "Nie znaleziono lokalizacji",
    "geocodingHint": "Pokazano: {{displayName}}"
  },
  "filters": {
    "toggleLabel": "Filtry",
    "hideLabel": "Ukryj filtry",
    "clearFiltersLabel": "Wyczyść filtry",
    "clearLabel": "Wyczyść",
    "rangeMinLabel": "Min",
    "rangeMaxLabel": "Max",
    "applyLabel": "Zastosuj",
    "foundCount": "Znaleziono:",
    "pinsLabel": "nośników",
    "countLabel": "nośników",
    "allLabel": "Wszystkie",
    "noPhoto": "Bez zdjęcia",
    "availability": "Dostępność",
    "searchPlaceholder": "Szukaj...",
    "selectedCountLabel": "{{n}} wybranych",
    "getClearAriaLabel": "Wyczyść filtr {{fieldId}}",
    "clearAllLabel": "Wyczyść wszystkie",
    "addFilterLabel": "Dodaj filtr",
    "fields": {
      "formatCode": "Format",
      "region": "Województwo",
      "county": "Powiat",
      "agglomeration": "Aglomeracja",
      "city": "Miasto",
      "supplierId": "Dostawca",
      "lighting": "Oświetlenie",
      "supplierNumber": "Nr dostawcy",
      "grwId": "ID GRW",
      "mediaType": "Typ nośnika",
      "location": "Lokalizacja",
      "locationSearchPlaceholder": "Szukaj województwa, powiatu, aglomeracji, miasta…",
      "locationInfoHint": "Wybrane obszary sumują się (LUB) — dodawaj lokalizacje, aby poszerzyć wyniki. Pozostałe filtry zawężają wynik.",
      "locationInfoHintLabel": "Informacja o filtrze lokalizacji",
      "administrativeArea": "Dzielnica",
      "material": "Materiał",
      "multiformat": "Multiformat",
      "tags": "Tagi",
      "address": "Adres",
      "area": "Powierzchnia",
      "width": "Szerokość",
      "height": "Wysokość",
      "audience": "Widownia",
      "catalogPrice": "Cena katalogowa",
      "rent": "Czynsz",
      "exposureCost": "Koszt ekspozycji",
      "additionalCosts": "Koszty dodatkowe",
      "discountedPrice": "Cena po rabacie",
      "lastMinutePrice": "Cena last minute",
      "starterPrice": "Na start",
      "productionCost": "Koszt produkcji",
      "installationCost": "Koszt montażu",
      "dismantlingCost": "Koszt demontażu",
      "clientProduction": "Produkcja",
      "clientInstallation": "Montaż",
      "clientDismantling": "Demontaż",
      "clientAdditionalFees": "Opłaty dodatkowe",
      "notes": "Uwagi",
      "roadNumber": "Nr drogi"
    }
  },
  "legend": {
    "title": "Typ nośnika",
    "types": {
      "billboard": "Billboard",
      "backlight": "Backlight",
      "citylight": "Citylight",
      "słup": "Słup",
      "cityscroll": "Cityscroll",
      "konstrukcja": "Konstrukcja",
      "wielki format": "Wielki format",
      "mural": "Mural",
      "dooh": "DOOH",
      "inne": "Inne"
    }
  },
  "errorState": "Nie udało się załadować mapy",
  "retryButton": "Spróbuj ponownie",
  "offerContext": {
    "bar": {
      "message": "Dodajesz do oferty: {{offerName}}",
      "returnLabel": "Wróć do oferty",
      "exitAriaLabel": "Zakończ dodawanie do oferty"
    }
  },
  "pinPopup": {
    "close": "Zamknij",
    "details": "Szczegóły",
    "quickAdd": "Dodaj do oferty",
    "maps": "Mapa",
    "format": "Format",
    "dimensions": "Wymiary",
    "area": "Powierzchnia",
    "supplier": "Dostawca",
    "catalogPrice": "Cena kat.",
    "illumination": "Oświetlenie",
    "illuminated": "Tak",
    "notIlluminated": "Nie",
    "noPhoto": "Brak zdjęcia",
    "photoAlt": "Nośnik",
    "loadError": "Nie udało się załadować nośnika",
    "retry": "Spróbuj ponownie",
    "quickAddPicker": {
      "title": "Dodaj do oferty",
      "subtitle": "Wybierz ofertę docelową",
      "draftUnitLabel": "nośników",
      "draftSummarySeparator": "•",
      "pendingUnitsLabel": "Dodajesz",
      "targetOfferLabel": "Oferta docelowa",
      "searchPlaceholder": "Szukaj oferty",
      "createNewLinkLabel": "Dodaj nową",
      "changeSelectionLabel": "Zmień",
      "cancelChangeLabel": "Anuluj zmianę",
      "backToExistingLabel": "Wróć do istniejących",
      "lastUsedHintLabel": "Ostatnio używana oferta jest wybrana domyślnie.",
      "destinationLabel": "Dodasz do",
      "creationStatusHintLabel": "Nowa oferta zostanie utworzona przy zapisie.",
      "noPreselectionLabel": "Nie wybrano jeszcze oferty.",
      "noDraftsLabel": "Brak ofert roboczych.",
      "noPermissionLabel": "Nie masz uprawnień do edycji ofert.",
      "noResultsLabel": "Nie znaleziono oferty pasującej do wyszukiwania.",
      "createNewLabel": "Nowa oferta",
      "createNewHint": "Utwórz nową ofertę roboczą.",
      "clientFieldLabel": "Klient",
      "clientFieldPlaceholder": "Wybierz klienta",
      "salespersonFieldLabel": "Handlowiec",
      "salespersonFieldPlaceholder": "Wybierz handlowca",
      "salespersonFieldLockedHint": "Nie masz uprawnień do przypisania oferty innemu handlowcowi.",
      "campaignDurationLabel": "Czas trwania kampanii",
      "campaignDurationPlaceholder": "Wybierz zakres dat",
      "campaignDurationInvalidRangeLabel": "Data zakończenia musi być taka sama lub późniejsza niż data początkowa",
      "confirmExistingLabel": "Dodaj",
      "confirmNewLabel": "Utwórz i dodaj",
      "cancelLabel": "Anuluj",
      "openFullFormLabel": "Otwórz pełny formularz",
      "openFullFormHint": "Dalsza konfiguracja w pełnym formularzu.",
      "validationClientRequiredLabel": "Wybierz klienta"
    }
  },
  "pois": {
    "categories": {
      "amenity-school": "Szkoły",
      "amenity-kindergarten": "Przedszkola",
      "amenity-hospital": "Szpitale",
      "amenity-clinic": "Przychodnie",
      "amenity-pharmacy": "Apteki",
      "shop-supermarket": "Supermarkety",
      "shop-convenience": "Sklepy convenience",
      "shop-grocery": "Sklepy spożywcze",
      "shop-mall": "Galerie handlowe",
      "amenity-fuel": "Stacje paliw",
      "railway-station": "Stacje kolejowe",
      "aeroway-aerodrome": "Lotniska",
      "amenity-university": "Uczelnie wyższe",
      "amenity-college": "Kolegia",
      "amenity-bank": "Banki",
      "amenity-atm": "Bankomaty",
      "leisure-park": "Parki",
      "office-government": "Urzędy",
      "amenity-townhall": "Ratusze",
      "tourism-attraction": "Atrakcje turystyczne",
      "tourism-museum": "Muzea",
      "amenity-place_of_worship": "Miejsca kultu"
    },
    "layerPanel": {
      "showPois": "Warstwy POI",
      "close": "Zamknij"
    },
    "popup": {
      "searchWithin": "Szukaj w promieniu",
      "radiusMeters": "{{meters}}m",
      "radiusKm": "{{km}}km",
      "brand": "Marka",
      "close": "Zamknij"
    },
    "nearbySection": {
      "heading": "Pobliskie POI",
      "empty": "Brak pobliskich punktów zainteresowania",
      "distanceM": "{{distance}}m"
    },
    "filterSection": {
      "label": "W pobliżu POI",
      "categoryLabel": "Kategoria",
      "radiusLabel": "Promień",
      "categoryPlaceholder": "Wybierz kategorię...",
      "categorySearchPlaceholder": "Szukaj kategorii...",
      "categoryNoResults": "Brak wyników",
      "radiusPlaceholder": "Wybierz promień...",
      "applyLabel": "Zastosuj",
      "activePill": "W pobliżu: {{label}} ({{radius}})",
      "nearPoiPill": "W promieniu {{radius}} od POI: {{name}}",
      "unknownPoi": "POI"
    }
  },
  "transportLayers": {
    "nearbyTitle": "Transport w pobliżu",
    "lineInfo": {
      "closeAriaLabel": "Zamknij"
    },
    "controls": {
      "sectionLabel": "Warstwy transportowe",
      "publicTransportLabel": "Transport publiczny",
      "roadsLabel": "Drogi główne",
      "zoomHintPublic": "Przybliż mapę, aby zobaczyć transport",
      "zoomHintRoads": "Przybliż mapę, aby zobaczyć drogi",
      "loadingLabel": "Wczytywanie...",
      "emptyLabel": "Brak danych w tym obszarze"
    },
    "legend": {
      "publicTransport": "Transport publiczny",
      "roads": "Drogi główne"
    },
    "modeLabels": {
      "road": "Droga krajowa - główny korytarz",
      "autobusy": "Transport publiczny - autobus",
      "tramwaje": "Transport publiczny - tramwaj",
      "kolej-metro": "Transport publiczny - kolej / metro",
      "metro": "Transport publiczny - metro",
      "unknown": "Transport publiczny - relacja OSM"
    }
  },
  "administrativeAreaLayer": {
    "controls": {
      "toggleLabel": "Obszary administracyjne",
      "errorLabel": "Nie udało się wczytać granic obszarów administracyjnych"
    }
  },
  "areaSelection": {
    "pageTitle": "Mapa — zaznaczanie obszaru",
    "tools": {
      "pan": "Przesuń mapę",
      "lasso": "Lasso",
      "rectangle": "Prostokąt",
      "circle": "Okrąg",
      "modeAdd": "Dodaj do zaznaczenia",
      "modeRemove": "Usuń z zaznaczenia",
      "modeFresh": "Zastąp zaznaczenie",
      "lassoAdd": "Lasso: dodaj do zaznaczenia",
      "lassoRemove": "Lasso: usuń z zaznaczenia",
      "rectangleAdd": "Prostokąt: dodaj do zaznaczenia",
      "circleAdd": "Okrąg: dodaj do zaznaczenia",
      "clearShapes": "Usuń wszystkie kształty",
      "polygon": "Wielokąt",
      "pointSelect": "Zaznacz klikając",
      "shortcut": {
        "pan": "V",
        "lasso": "L",
        "rectangle": "R",
        "circle": "C",
        "polygon": "P",
        "pointSelect": "S"
      }
    },
    "selectionCard": {
      "selectedCount": "{{count}} nośników zaznaczonych",
      "visibleCount": "{{count}} widocznych",
      "clearSelection": "Wyczyść zaznaczenie",
      "saveToOffer": "Zapisz do oferty...",
      "bulkDownload": "Pobierz specyfikacje"
    },
    "drawBadge": "{{count}} nośników",
    "emptyShapeToast": "0 nośników w kształcie",
    "saveDialog": {
      "title": "Zapisz do oferty roboczej",
      "createNew": "Utwórz nową ofertę roboczą",
      "confirmButton": "Dodaj {{count}} nośników do oferty",
      "cancelButton": "Anuluj",
      "close": "Zamknij"
    },
    "successToast": "{{count}} nośników dodano do {{offerName}}",
    "filterToggle": "Filtry",
    "hideFilters": "Ukryj filtry",
    "clearFilters": "Wyczyść filtry",
    "foundCount": "Znaleziono:",
    "pinsLabel": "nośników"
  },
  "admin": {
    "pois": {
      "pageTitle": "Dane geograficzne",
      "heading": "Punkty zainteresowania",
      "addButton": "Dodaj POI",
      "deleteButton": "Usuń",
      "makePublicButton": "Ustaw jako publiczny",
      "makeInternalButton": "Ustaw jako wewnętrzny",
      "viewOnMapButton": "Zobacz na mapie",
      "deleteConfirm": "Czy na pewno chcesz usunąć POI {{name}}?",
      "internal": "Wewnętrzny",
      "columns": {
        "name": "Nazwa",
        "category": "Kategoria",
        "internalOnly": "Wewnętrzny",
        "createdAt": "Dodano"
      },
      "form": {
        "nameRequired": "Nazwa jest wymagana",
        "categoryRequired": "Kategoria jest wymagana",
        "nameLabel": "Nazwa",
        "categoryLabel": "Kategoria",
        "latLabel": "Szerokość geogr.",
        "lngLabel": "Długość geogr.",
        "internalOnlyLabel": "Tylko wewnętrzny",
        "namePlaceholder": "np. Szkoła Podstawowa nr 1",
        "categoryPlaceholder": "Wybierz kategorię...",
        "latError": "Szerokość musi być w zakresie -90 do 90",
        "lngError": "Długość musi być w zakresie -180 do 180",
        "submitLabel": "Dodaj POI",
        "submittingLabel": "Dodawanie...",
        "apiError": "Wystąpił błąd. Spróbuj ponownie."
      },
      "toast": {
        "createSuccess": "POI został dodany",
        "deleteSuccess": "POI został usunięty",
        "deleteError": "Nie udało się usunąć POI. Spróbuj ponownie."
      },
      "deleteDialog": {
        "title": "Usuń POI",
        "confirm": "Usuń",
        "cancel": "Anuluj"
      },
      "allCategories": "Wszystkie kategorie",
      "categoryFilterLabel": "Filtruj według kategorii",
      "showDeletedLabel": "Pokaż usunięte",
      "showListLabel": "Pokaż listę",
      "hideListLabel": "Ukryj listę",
      "deletedBadge": "Usunięty",
      "stats": {
        "osmCount": "POI z OpenStreetMap",
        "customCount": "Własne POI",
        "deletedCount": "Usunięte",
        "lastImport": "Ostatni import",
        "neverImported": "Brak danych",
        "categoryBreakdown": "Podział według kategorii",
        "manageCta": "Zarządzaj własnymi POI",
        "manageDesc": "Dodawaj i usuwaj własne punkty zainteresowania, które nie pochodzą z OpenStreetMap.",
        "importNote": "Dane z OSM są importowane automatycznie co niedzielę o 02:00 UTC. Możliwe jest też ręczne uruchomienie importu poleceniem task worker:poi-import."
      },
      "importTrigger": {
        "triggerButton": "Uruchom import",
        "triggerButtonRunning": "Import w toku...",
        "statusLabel": "Status importu",
        "statusIdle": "Bezczynny",
        "statusRunning": "W toku",
        "statusCompleted": "Zakończony",
        "statusFailed": "Błąd",
        "lastRunAt": "Ostatnie uruchomienie",
        "lastError": "Ostatni błąd",
        "triggerSuccess": "Import POI został uruchomiony",
        "triggerError": "Nie udało się uruchomić importu",
        "triggerConflict": "Import jest już w toku"
      }
    },
    "transportLayers": {
      "importTrigger": {
        "triggerButton": "Uruchom import",
        "triggerButtonRunning": "Import w toku...",
        "statusLabel": "Import warstw transportu",
        "statusIdle": "Bezczynny",
        "statusRunning": "W toku",
        "statusCompleted": "Zakończony",
        "statusFailed": "Błąd",
        "lastRunAt": "Ostatnie uruchomienie",
        "lastError": "Ostatni błąd",
        "triggerSuccess": "Import warstw transportu został uruchomiony",
        "triggerError": "Nie udało się uruchomić importu warstw transportu",
        "triggerConflict": "Import warstw transportu jest już w toku"
      }
    },
    "adminBoundaries": {
      "importTrigger": {
        "title": "Import granic administracyjnych",
        "description": "Wczytaj dane referencyjne polskich województw i powiatów. Import jest idempotentny — ponowne uruchomienie nie tworzy duplikatów.",
        "triggerButton": "Uruchom import",
        "triggerButtonRunning": "Import w toku...",
        "statusIdle": "Bezczynny",
        "statusRunning": "W toku",
        "statusCompleted": "Zakończony",
        "statusFailed": "Błąd",
        "lastRunAt": "Ostatnie uruchomienie",
        "lastError": "Ostatni błąd",
        "resultSummary": "Dodano {{inserted}}, pominięto {{skipped}}",
        "triggerError": "Nie udało się uruchomić importu granic administracyjnych",
        "triggerConflict": "Import granic administracyjnych jest już w toku"
      }
    }
  }
}
